export const invitationSourcesTypes = {
  USER: 'USER',
  TEAM: 'TEAM',
  COMPANY: 'COMPANY'
}

export const membersTableEntityTypes = {
  PROJECT: 'entityTypeProject',
  TEAM: 'entityTypeTeam',
  COMPANY: 'entityTypeCompany'
}